module.exports = __webpack_public_path__ + "img/D.a0994405.svg";